import { createSelector } from 'reselect';
import type IState from 'services/state';

export const getIsUserActionRequested = createSelector(
  (state: IState) => state.navigation.isUserActionRequested,
  (isUserActionRequested: boolean) => isUserActionRequested,
);
